import React, { useEffect } from "react";
import { Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdOutlineImportContacts } from "react-icons/md";
import { useForms } from "./../../use-forms/index"
import { z } from "zod"
import { connect } from 'react-redux';

const preprocess = (value) => (!!value ? value : undefined)
const formSchema = z.object({
  term_of_use: z.preprocess(
    preprocess,
    z.coerce.boolean().refine(
      (value) => value === true,
      "Você deve concordar com os termos de uso para continuar."
    )
  )
})

//Form step 3
function Index(props) {
  const {
    register,
    setValue,
    setError,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  useEffect(async () => {
    clearErrors()
    setValue('term_of_use', props.form.term_of_use)
  }, [])

  const onSubmitForm = async data => {
    //post or validate data to/on api endpoint here
    //on success
    props?.submit(data)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-10 col-lg-10">
      <div className="background"></div>
      <h2 className="mb-3"><MdOutlineImportContacts /> Termos e Condições de Uso</h2>
      <p>Leia as informações correspondentes ao termo de uso do serviço, marque se concorda, e salve para continuar.</p>

      <iframe
        className="use-term"
        src={`https://policy.sigmobi.com/p/term/1`}
        height="100%"
        width="100%"
      ></iframe>

      <Row>
        <Col>
          <Form.Group as={Col} className="mb-2 use-term-formgroup">
            <Form.Label>
              <b>Concorda com os termo de uso do serviço?</b> &nbsp; <Form.Check {...register('term_of_use')} />
            </Form.Label>
            {errors.term_of_use?.message && <div className="text-danger">{errors.term_of_use?.message}</div>}
          </Form.Group>
        </Col>
      </Row>

      <ButtonGroup className="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mt-5 mb-5">
        <Button onClick={props?.back} className="btn btn-light btn-large" type="button">Voltar</Button>
        <Button className="btn btn-primary btn-large centerButton" type="submit">Salvar</Button>
      </ButtonGroup>
    </Form>
  );
}

const mapStateToProps = (state) => {
  return {}
};

export default connect(mapStateToProps)(Index);